import { AxiosError } from 'axios';
import { NewFile, ErrorModel, NewMedia } from '@askporter/client-grieg-lyric';
import { AdminMediaUploadConfig, APIOptions, SimplifiedIAPIClient, UploadedFile } from '../..';

export const uploadFiles = async (
  filesToUpload: Array<File>,
  API: () => SimplifiedIAPIClient,
  captureException: (error: unknown, context?: Record<string, unknown>) => void,
  adminMediaUploadConfig?: AdminMediaUploadConfig,
): Promise<Array<UploadedFile>> => {
  return Promise.all(
    filesToUpload.map(async (file) => {
      try {
        const adminMediaUploadPayload: NewMedia | undefined = adminMediaUploadConfig
          ? {
              type: adminMediaUploadConfig.mediaType,
              filename: file.name,
              fileSize: file.size,
            }
          : undefined;

        const defaultFileUploadPayload: NewFile = { pathPrefix: '/', filename: file.name };

        const { data } = await API().post({
          path: adminMediaUploadConfig ? 'admin/media' : 'files',
          payload: adminMediaUploadConfig ? adminMediaUploadPayload : defaultFileUploadPayload,
        });

        const putRequest: APIOptions = {
          path: data.signedUploadPath,
          payload: file,
          authHeader: false,
          isGrieg: false,
        };

        if (file.type) {
          putRequest.additionalHeaders = { 'Content-Type': file.type };
        }

        await API().put(putRequest);

        const objectURL = URL.createObjectURL(file); //this a temporary blob url to use whilst the backend file path is resolved.

        return {
          uid: data.uid,
          urn: data.urn,
          name: file.name,
          signedUploadPath: data.signedUploadPath,
          addedAt: new Date().toISOString(),
          objectURL,
          filePath: data.filePath,
        };
      } catch (error) {
        const errorWithResponse = error as AxiosError<ErrorModel>;
        captureException(error, {
          extra: { fileName: file?.name, response: errorWithResponse?.response?.data?.message },
        });
        return { name: file?.name, error };
      }
    }),
  );
};
